export function hasFlag (flags, flag) {
  return (flags & flag) === flag
}

export function setFlag (flags, flag) {
  return flags | flag
}

export function clearFlag (flags, flag) {
  return flags & ~flag
}

export function toggleFlag (flags, flag) {
  if (!hasFlag(flags, flag)) {
    return setFlag(flags, flag)
  }
  return clearFlag(flags, flag)
}

export default {
  hasFlag,
  toggleFlag,
  setFlag,
  clearFlag
}
